import { Button, Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierConnectControl extends Layout {
    buttonTestConnection: Button;
    buttonViewAvailableCarriers: Button;
    checkboxActive: Checkbox;
    panelActive: Panel;
    panelButtons: Panel;
    panelCarrierConnectControl: Panel;
    sourceContractManagementControl: DataSource;
    textboxAccountNumber: Textbox;
    textboxAccountPassword: Textbox;
    textboxAccountUserId: Textbox;
    textboxEndpointUrl: Textbox;
    textboxRefSetting1: Textbox;
    textboxRefSetting2: Textbox;
}
